// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-blocks-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:1.25rem;width:100%;height:auto}.mention-wrapper{width:100%}.load-observer{display:block;width:100%;height:3.125rem;-webkit-box-ordinal-group:2001;-ms-flex-order:2000;order:2000}.loading-list{-webkit-box-ordinal-group:101;-ms-flex-order:100;order:100}", ""]);
// Exports
module.exports = exports;
